module.exports = require('./helpers/bundle-url').getBundleURL('4SxJc') + "css.worker.122fe8e1.js";